<!-- best seller -->
<section class="best-seller mb-4 best-seller-allProducts my-4" *ngFor="let brand of allBestSeller;let i=index">
    <h6 class="bg-main-color text-white px-4 py-2 rounded-pill text-uppercase overflow-hidden mb-4">
        <span class="float-left">{{brand.name_en}}</span> 
    </h6>
    <!-- Best Seller Products-->

    <div class="best-seller-products">
        <div class="row">
            
            
            <div class="col-lg-3 col-sm-6 mb-3" *ngFor="let product of brand.product" >
                <app-product [product]="product" [categoryName]="brandName"></app-product>
                <!-- <div class="proctuct bg-white position-relative text-center" >
                    <span
                        class="offer bg-secondary-color text-white position-absolute px-3" >- {{product.discount}}%</span>
                    <span class="favourite text-secondary-color  position-absolute" ><i
                            class="far fa-heart"></i></span>
                    <div class="product-img">
                        <img src="{{product.images[0].image}}" alt="{{product.name_en}}" class="img-fluid img-contain">
                    </div>
                    <rating [(ngModel)]="product.rate" [max]="5" [readonly]="true"></rating>
             
                    <div class="product-title">
                        <h6 class="text-truncate"><a routerLink="../details/{{product.id}}"  class='text-dark'>{{product.name_en}}</a></h6>
                    </div>
                    <div class="product-info overflow-hidden mb-2">
                        <span class="text-secondary-color font-weight-bold">{{product.price}} SAR </span>
                        <span
                            class="category rounded-pill px-2 d-inline-block float-right">{{brand.department.name_en}}</span>
                    </div>
                    <div class="add-cart bg-main-color text-white p-2">
                        <i class="fas fa-shopping-cart"></i> Add To Cart
                    </div>
                </div>  -->
            </div>
        </div>
    </div>
    <!-- Best Seller Products-->
</section>
<!-- ./best seller -->